import * as React from "react";

import {
    TextField,
    Typography,
    Box,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Button,
    InputLabel,
    styled
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useUtilityContext } from "../../utility-provider";
import { apiRequest } from "../../api/ApiCall";
import { LOCAL_CONSTANT } from "../Const";
import { userLogging } from "../../utility/firestore";
import { useUserContext } from "../../user-provider";
import {
    callApi,
    initCommentData,
    deficiencyCommentDetail
} from '../subPage/DeficiencyComment/DeficiencyCommentFunction';
import { setDeficiencyComment } from "../../features/deficiencyCommentSlice";
import Paper, { PaperProps } from "@mui/material/Paper";
import Draggable from "react-draggable";
import { setColumnLogicName } from "../Common";

export interface commentDialogProps {
    props: {
        userType: string;
        open: boolean;
        params: any;
        handleModal: React.Dispatch<React.SetStateAction<boolean>>;
        handleSaveComment: () => void;
    };
}

//不備コメントモーダル画面を移動
function PaperComponent(props: PaperProps) {
    return (
        <Draggable
            handle="#draggable-dialog-title" //ドラック可能
            cancel={'[class*="MuiDialogContent-root"]'} //ドラックを無効
        >
            <Paper {...props} />
        </Draggable>
    );
}
//不備コメントモーダルの背景を透明
const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiBackdrop-root": {
        backgroundColor: "transparent",
    },
}));


export const Comment: React.FC<commentDialogProps> = ({ props }) => {
    const [open, setOpen] = React.useState<boolean>(false);
    const [disabled, setDisabled] = React.useState<boolean>(true);
    const [comment, setComment] = React.useState("");
    //不備コメントリロード
    const [reload, setReload] = React.useState<boolean>(false);
    //ロングページオブジェクト 候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //ステータス管理sequence
    const statusSeq = useAppSelector((state) => state.longPage.locationBase.status_seq);
    //不備コメント一覧
    const listDeficiencyComment = useAppSelector((state) => state.deficiencyComment);
    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        setOpen(props.open);
        setComment(""); //コメント初期化
    }, [props.open]);

    const handleCommentChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setComment(e.target.value);
        if (e.target.value) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    };

    const registComment = async () => {
        //モーダルを閉じる
        props.handleSaveComment();
        //不備コメントを登録
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/regist",
            query: {
                plan_area_id: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                status_seq: statusSeq,
                table_name: props.params.table_name,
                column_name: props.params.column_name,
                comment: comment,
                sub_key: props.params.sub_key
            },
        };
        // userLogging
        userLogging(LOCAL_CONSTANT.FUNCTION_NAME.COMMENT_REGIST, params, user);
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            await apiRequest(params);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            setComment("");
            //不備コメントリロード
            setReload(true);
        } catch (e) {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            setComment("");
            //不備コメントリロード
            setReload(true);
        }
    };

    //登録後に不備コメント一覧を取得
    React.useEffect(() => {
        if (reload) {
            deficiencyCommentRelaod();
        }
    }, [reload]);
    
    //不備コメント一覧を取得関数
    const deficiencyCommentRelaod = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            callApi("getDeficiencyComment", objLongPageParam.planAreaId, objLongPageParam.branch).then((res: any) => {
                if (res.length > 0) {
                    dispatch(setDeficiencyComment(initCommentData(res)));
                }
            });
            setReload(false);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        } catch (e) {
            console.log(e);
            setReload(false);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }
    }

    const closeComment = () => {
        //モーダルを閉じる
        props.handleSaveComment();
    };

    // 項目ごとの不備コメント
    const deficiencyComments = deficiencyCommentDetail(listDeficiencyComment, props.params.table_name, props.params.column_name, props.params.sub_key);

    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => props.handleModal(false)}
                PaperComponent={PaperComponent} //PaperComponentをモーダル全体をドラック可能
                aria-labelledby="draggable-dialog-title"
                fullWidth
            >
                <DialogTitle
                    style={{ cursor: "move" }} //スタイルを追加し、カーソルを変更しドラック可能
                    id="draggable-dialog-title"
                >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <InputLabel sx={{ padding: "10px" }}>不備コメント</InputLabel>
                        {setColumnLogicName(props.params.table_name, props.params.column_name)}
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {deficiencyComments.length !== 0 && (
                        <Box mb={2}>
                            <Typography>登録済み不備コメント</Typography>
                            {deficiencyComments.map((deficiencyComment:any, index: number) => (
                                <TextField
                                    key={index}
                                    fullWidth
                                    variant="filled"
                                    value={deficiencyComment.comment}
                                    multiline
                                    InputProps={{
                                        readOnly: true,
                                        style: {
                                            padding: "16px 12px", // 上下左右のパディングを設定
                                        },
                                    }}
                                />
                            ))}
                        </Box>
                    )}
                    {/* RRの場合、新規で不備コメントを登録 */}
                    {props.userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                        <Box>
                            <Typography>新規登録不備コメント</Typography>
                            <TextField
                                variant="outlined"
                                fullWidth
                                value={comment}
                                multiline
                                onChange={(e) => handleCommentChange(e)}
                            />
                        </Box>
                    )}
                </DialogContent>
                <Box sx={{ display: "flex", justifyContent: "space-around", margin: "10px" }}>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => closeComment()}
                        >
                            {LOCAL_CONSTANT.LABEL.CANCEL}
                        </Button>
                    </DialogActions>
                    {/* RRの場合、登録ボタンを表示 */}
                    {props.userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                        <DialogActions>
                            <Button
                                variant="contained"
                                color="success"
                                size="small"
                                disabled={disabled}
                                onClick={() => registComment()}>
                                {LOCAL_CONSTANT.LABEL.REGIST_LABEL}
                            </Button>
                        </DialogActions>
                    )}
                </Box>
            </CustomDialog>
        </>
    );
};

export default Comment;
